export default function TranslateFilter (
    $translates
){
    'ngInject';
    return ( input ) => {
        return $translates.get(input) || input;
    }
}


/** WEBPACK FOOTER **
 ** ./frontend/components/translates/translates.filter.js
 **/